import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyChEniFx32nBnrcOvditSwLTglTBPTCWVQ",
  authDomain: "connections-d1be1.firebaseapp.com",
  databaseURL: "https://connections-d1be1-default-rtdb.firebaseio.com",
  projectId: "connections-d1be1",
  storageBucket: "connections-d1be1.appspot.com",
  messagingSenderId: "89340878669",
  appId: "1:89340878669:web:83a91ab3aab71257c66104",
  measurementId: "G-HZRYF1DR6N"
};

const app = initializeApp(firebaseConfig);
 const auth = getAuth(app);
 const db = getDatabase(app);
 const storage = getStorage(app);

export { auth, db, storage };
